import { useLayoutEffect } from 'react';
import { DATA_QA_MOBILE_FOOTER_CONTAINER } from '../constants';

export const useAddBodyPadding = () => {
  useLayoutEffect(() => {
    const fixedContainer = document.querySelector(`[data-qa="${DATA_QA_MOBILE_FOOTER_CONTAINER}"]`);

    if (!fixedContainer) return;

    const extraHeight = fixedContainer.getBoundingClientRect().height;
    const originalPadding = window.getComputedStyle(document.body).paddingBottom;
    const originalValue = parseFloat(originalPadding) || 0;

    document.body.style.paddingBottom = `${originalValue + extraHeight}px`;
  }, []);
};
